(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-furniture"]) return;
  try {
    

  $('.product-main-image').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false
  });

  $('.product-thumbs').not('.slick-initialized').slick({
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    vertical: true,
    prevArrow: ".thumb-prev",
    nextArrow: ".thumb-next",
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
if (!Shopify.designMode) {
  var loadProductRecommendationsIntoSection = function() {
   // Look for an element with class 'product-recommendations'
   var productRecommendationsSection = document.querySelector(".product-recommendations");
   if (productRecommendationsSection === null) { return; }
   // Read product id from data attribute
   var productId = productRecommendationsSection.dataset.productId;
   // Read base URL from data attribute
   var baseUrl = productRecommendationsSection.dataset.baseUrl;
   // Read limit from data attribute
   var limit = productRecommendationsSection.dataset.limit;
   // Build request URL
   var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
   // Create request and submit it using Ajax
   var request = new XMLHttpRequest();
   request.open("GET", requestUrl);
   request.onload = function() {
     if (request.status >= 200 && request.status < 300) {
       var container = document.createElement("div");
       container.innerHTML = request.response;
       productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
     }
   };
   request.send();
  };

  // Listen for changes done in the Theme Editor
  document.addEventListener("shopify:section:load", function(event) {
   if (event.detail.sectionId === "product-recommendations") {
     loadProductRecommendationsIntoSection();
   }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();
}

  } catch(e) { console.error(e); }
})();
})();
